
import { mapState } from 'vuex'
// import { Editor, EditorContent } from '@tiptap/vue-2'
// import StarterKit from '@tiptap/starter-kit'

export default {
  name: 'Content',
  // components: { EditorContent },
  props: {
    title: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String,
      default: null,
    },
  },
  data() {
    return {
      editor: null,
    }
  },
  computed: {
    ...mapState({ brand: (state) => state.brand.brand }),

    cssVars() {
      return { '--primary-color': this.brand.primary_color }
    },
  },
  mounted() {
    //   this.editor = new Editor({
    //     content: this.text,
    //     extensions: [
    //       StarterKit.configure({
    //         heading: {
    //           levels: [1, 2, 3],
    //         },
    //       }),
    //     ],
    //     editable: false,
    //   })
  },
  // beforeDestroy() {
  //   this.editor.destroy()
  // },
}
